import axiosInstance from "./axiosInstance";

const expenseHeadService  = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/expensehead/createhead', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/expensehead/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/expensehead/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchById: async (id) => {
        try {
            const response = await axiosInstance.get('/expensehead/get/' + id);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/expensehead/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default expenseHeadService;
